import { css } from 'lit';

export default css`
  :host {
    display: inline-block;
  }

  .loader {
    border-radius: 50%;
    border-style: solid;
    border-color: var(--color-secondary, #2594E3);
    border-top-color: transparent; /* Creates the "not-quite-complete" effect */
    animation: spin 1s linear infinite;
    box-sizing: border-box;
  }

  /* Sizes */
  :host([size="giant"]) .loader {
    width: 56px;
    height: 56px;
    border-width: 6px;
  }

  :host([size="large"]) .loader {
    width: 48px;
    height: 48px;
    border-width: 6px;
  }

  :host([size="medium"]) .loader {
    width: 40px;
    height: 40px;
    border-width: 5px;
  }

  :host([size="small"]) .loader {
    width: 32px;
    height: 32px;
    border-width: 4px;
  }

  :host([size="tiny"]) .loader {
    width: 24px;
    height: 24px;
    border-width: 4px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;